import { type Token } from '@getgo/auth-client'
import { navigateToUrl } from '../../common/helpers'
import { DesktopCompanionConnectionStatus, type DesktopCompanionStatusChangedEvent } from '@getgo/container-client'
import { getToken, setToken } from '../auth/token'
import { navigateToExternal } from '../../common/dom-helpers'
import { type ExternalInterface } from './external-interface'
import { refreshAuthTimer } from '../auth/refresh'
import { initializeContainerInfo } from '../container/container-info'

export const externalInterfaceConnectionHandler = async (externalInterface: ExternalInterface) => {
  const handleAuthToken = (payload: Token) => {
    const actualToken = getToken()
    if (actualToken?.access_token !== payload?.access_token) {
      setToken(payload)
      refreshAuthTimer(payload)
      navigateToExternal(window.origin)
    } else {
      // getDefaultRoute(navigationItems) instead of /home
      // we previously used getStoredCurrentRoute which brought an issue of dependencies with the eventemitter
      navigateToUrl('/home')
    }
  }

  const handleConnectionChanged = (e: DesktopCompanionStatusChangedEvent) => {
    if (e.connectionStatus === DesktopCompanionConnectionStatus.connected) {
      externalInterface.send({ type: 'request-auth-token', payload: {} })
    } else if (e.connectionStatus === DesktopCompanionConnectionStatus.disconnected) {
      navigateToUrl('/landing')
      externalInterface.connect()
    }
  }

  const handleRequestAuthToken = () => {
    const interval = setInterval(() => {
      const token = getToken()

      if (token) {
        clearInterval(interval)
        externalInterface.send({ type: 'auth-token', payload: token })
      }
    }, 100)
  }

  await initializeContainerInfo()

  if (externalInterface.isIntegration) {
    externalInterface.addCallback('auth-token', handleAuthToken)
    externalInterface.addConnectionCallback(handleConnectionChanged)
    externalInterface.connect()
  } else if (externalInterface.isCompanion) {
    externalInterface.addCallback('request-auth-token', handleRequestAuthToken)
    externalInterface.connect()
  }
}
